import { render, staticRenderFns } from "./InplayList.vue?vue&type=template&id=fa65db6a&scoped=true"
import script from "./InplayList.vue?vue&type=script&lang=js"
export * from "./InplayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa65db6a",
  null
  
)

export default component.exports